angular.module('businessThread')
    .component('businessThreadShow', {
        bindings: {
            item: '<'
        },
        templateUrl: 'app/business-thread/show.html',
        controller: function ($scope, $state, $window, BusinessThread, BusinessThreadService, BusinessThreadLinkFlagService, BusinessThreadConst, BusinessThreadTimelineUi, Principal) {
            const emptyResourceItems = []
            const defaultFilters = () => ({
                search: null,
                dateFrom: null,
                dateTo: null,
                flags: [],
                showConfidential: false
            })
            const viewStateKey = () => BusinessThreadService.viewStateKey('show', this.item && this.item.id)

            this.BusinessThreadService = BusinessThreadService
            this.items = []
            this.filteredItems = []
            this.resourceItemsByType = {}
            this.visibleResourceTabs = []
            this.activeTabIndex = 0
            this.agreementIds = []
            this.invoiceIds = []
            this.orderIds = []
            this.taskIds = []
            this.todoIds = []
            this.workflowIds = []
            this.resourceTabs = [
                {type: 'LEAVE', index: 10, heading: 'Absencje', roles: ['ROLE_LEAVE_MODULE']},
                {type: 'INVOICE', index: 20, heading: 'DF', table: 'invoice', roles: ['ROLE_INVOICE_DOCUMENTS_MODULE']},
                {type: 'CLIENT', index: 30, heading: 'Kontrahenci', roles: ['ROLE_CLIENTS']},
                {type: 'LEAD', index: 40, heading: 'Leady', roles: ['ROLE_LEADS']},
                {type: 'PROPERTY', index: 50, heading: 'Lokale', roles: ['ROLE_PROPERTY']},
                {type: 'NOTE', index: 60, heading: 'Notatki', roles: ['ROLE_NOTES']},
                {type: 'WORKFLOW', index: 70, heading: 'Obieg spraw', table: 'workflow', roles: ['ROLE_WORKFLOW_MODULE']},
                {type: 'RENTAL_RESOURCE', index: 80, heading: 'Obsługa najmu', roles: ['ROLE_RENTAL_MODULE']},
                {type: 'PROPERTY_DEAL', index: 90, heading: 'Obsługa sprzedaży', roles: ['ROLE_PROPERTY_DEAL']},
                {type: 'PROJECT', index: 100, heading: 'Projekty', roles: ['ROLE_PROJECT']},
                {type: 'AGREEMENT', index: 110, heading: 'Umowy', table: 'agreement', roles: ['ROLE_CONTRACT_MODULE']},
                {type: 'RENTAL_AGREEMENT', index: 120, heading: 'Umowy najmu', roles: ['ROLE_RENTAL_MODULE']},
                {type: 'TASK', index: 130, heading: 'Zadania', table: 'task', roles: ['ROLE_TASKS']},
                {type: 'TODO', index: 140, heading: 'Zadania projektowe', table: 'todo', roles: ['ROLE_TODO']},
                {type: 'SERVICE_REQUEST', index: 150, heading: 'Zgłoszenia serwisowe', roles: ['ROLE_SERVICE_REQUEST']},
                {type: 'AGREEMENT_ORDER', index: 160, heading: 'Zlecenia', table: 'order', roles: ['ROLE_CONTRACT_MODULE']}
            ]
            this.resourceTypes = []
            this.resourceTypeCounts = {}
            this.flags = BusinessThreadLinkFlagService.flags
            this.showAllResourceTabs = false
            this.filters = defaultFilters()
            this.loading = false
            this.resetResourceCounts = () => {
                this.agreementCount = null
                this.invoiceCount = null
                this.orderCount = null
                this.taskCount = null
                this.todoCount = null
                this.workflowCount = null
            }
            this.resetResourceCounts()

            this.$onInit = () => {
                let viewState = BusinessThreadService.getViewState(viewStateKey())
                this.filters = angular.extend(defaultFilters(), viewState.filters || {})
                this.showAllResourceTabs = viewState.showAllResourceTabs === true
                this.activeTabIndex = viewState.activeTabIndex || 0
                this.load()
            }

            this.saveViewState = () => BusinessThreadService.saveViewState(viewStateKey(), {
                filters: this.filters,
                showAllResourceTabs: this.showAllResourceTabs,
                activeTabIndex: this.activeTabIndex
            })
            $scope.$watch(() => this.activeTabIndex, () => this.saveViewState())

            this.load = () => {
                if (!this.item || !this.item.id) {
                    return
                }

                this.saveViewState()
                this.loading = true
                this.resetResourceCounts()
                return BusinessThread.timeline({
                    id: this.item.id,
                    includeConfidential: this.filters.showConfidential === true
                }).$promise.then(items => {
                    this.items = items || []
                    this.resourceTypes = BusinessThreadTimelineUi.resourceTypes(this.items)
                    this.resourceTypeCounts = BusinessThreadTimelineUi.resourceTypeCounts(this.items)
                    this.applyFilters()
                }).finally(() => this.loading = false)
            }

            this.searchDocs = () => {
                this.saveViewState()
                this.applyFilters()
            }

            this.resetSearch = () => {
                this.filters = defaultFilters()
                this.saveViewState()
                this.load()
            }

            this.resourceLabel = BusinessThreadTimelineUi.resourceLabel
            this.resourceIcon = BusinessThreadTimelineUi.resourceIcon
            this.resourceTypeCount = type => this.resourceTypeCounts[type] || 0
            this.resourceTabItems = type => this.resourceItemsByType[type] || emptyResourceItems
            this.emptyResourceItems = emptyResourceItems
            this.emptyResourceText = () => 'Brak powiązanych rekordów'
            this.resourceTabCount = type => {
                let tab = this.resourceTabs.find(item => item.type === type)
                let tableCount = tab && tab.table ? this.resourceTableCount(tab.table) : null
                return tableCount == null ? (this.loading ? '...' : this.resourceTabItems(type).length) : tableCount
            }
            this.hasResourceTab = type => this.resourceTabItems(type).length > 0
            this.hasTabAuthority = tab => !tab.roles || Principal.hasAnyAuthority(tab.roles)
            this.updateVisibleResourceTabs = () => {
                let allowedResourceTabs = this.resourceTabs.filter(tab => this.hasTabAuthority(tab))
                this.visibleResourceTabs = this.showAllResourceTabs ? allowedResourceTabs : allowedResourceTabs.filter(tab => this.hasResourceTab(tab.type))
                if (this.activeTabIndex !== 0 && !this.visibleResourceTabs.some(tab => tab.index === this.activeTabIndex)) {
                    this.activeTabIndex = 0
                }
                this.saveViewState()
            }
            this.timelineEmptyText = () => this.emptyResourceText()
            this.tabCountLabel = count => this.loading || count == null ? '...' : count
            this.onAgreementLoaded = page => this.agreementCount = page.fullListSize || 0
            this.onInvoiceLoaded = page => this.invoiceCount = page.fullListSize || 0
            this.onOrderLoaded = page => this.orderCount = page.fullListSize || 0
            this.onTaskLoaded = page => this.taskCount = page.fullListSize || 0
            this.onTodoLoaded = page => this.todoCount = page.fullListSize || 0
            this.onWorkflowLoaded = page => this.workflowCount = page.fullListSize || 0
            this.resourceTableCount = table => ({
                agreement: this.agreementCount,
                invoice: this.invoiceCount,
                order: this.orderCount,
                task: this.taskCount,
                todo: this.todoCount,
                workflow: this.workflowCount
            })[table]
            this.resourceTableIds = table => ({
                agreement: this.agreementIds,
                invoice: this.invoiceIds,
                order: this.orderIds,
                task: this.taskIds,
                todo: this.todoIds,
                workflow: this.workflowIds
            })[table] || emptyResourceItems
            this.isResourceTableEmpty = tab => {
                if (!tab || !tab.table || this.loading) {
                    return false
                }
                let ids = this.resourceTableIds(tab.table)
                let count = this.resourceTableCount(tab.table)
                return !ids.length || count === 0
            }
            this.shouldShowResourceTable = tab => !this.isResourceTableEmpty(tab)
            this.timelineHref = () => BusinessThreadTimelineUi.timelineHref(this.item)
            this.openTimeline = event => {
                if (event && (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
                    return
                }
                if (!this.item || !this.item.id) {
                    return
                }
                if (event) {
                    event.preventDefault()
                }
                return $state.go('businessThreadTimelineFull', {id: this.item.id})
            }
            this.unlinkResource = item => {
                let unlink = BusinessThreadService.unlinkResource(item)
                return unlink && unlink.then ? unlink.then(() => this.load()).catch(angular.noop) : unlink
            }
            this.flagResource = (item, flag) => {
                let toggle = BusinessThreadLinkFlagService.toggleFlag(item, flag)
                return toggle && toggle.then ? toggle.then(() => this.load()).catch(angular.noop) : toggle
            }
            this.cancel = () => $window.history.back()
            this.applyFilters = () => {
                this.saveViewState()
                this.query = normalizeQuery(this.filters.search)
                this.filteredItems = BusinessThreadTimelineUi.filter(this.items, this.filters)
                this.resourceItemsByType = resourceItemsByType(this.filteredItems)
                this.updateVisibleResourceTabs()
                this.resetResourceCounts()
                this.updateResourceIds(BusinessThreadTimelineUi.filter(this.items, {
                    dateFrom: this.filters.dateFrom,
                    dateTo: this.filters.dateTo,
                    flags: this.filters.flags,
                    showConfidential: this.filters.showConfidential
                }))
            }

            this.updateResourceIds = items => {
                this.agreementIds = resourceIdsByType(items, 'AGREEMENT')
                this.invoiceIds = resourceIdsByType(items, 'INVOICE')
                this.orderIds = resourceIdsByType(items, 'AGREEMENT_ORDER')
                this.taskIds = resourceIdsByType(items, 'TASK')
                this.todoIds = resourceIdsByType(items, 'TODO')
                this.workflowIds = resourceIdsByType(items, 'WORKFLOW')
            }

            const resourceIdsByType = (items, resourceType) => (items || [])
                .filter(item => item.resourceType === resourceType && item.resourceId)
                .map(item => item.resourceId)
            const resourceItemsByType = items => (items || []).reduce((result, item) => {
                if (item.resourceType) {
                    result[item.resourceType] = result[item.resourceType] || []
                    result[item.resourceType].push(item)
                }
                return result
            }, {})
            const normalizeQuery = value => (value || '').toString().trim() || null

            $scope.$on(BusinessThreadConst.eventUpdate, () => $state.reload())
            $scope.$on('file.saved', () => $state.reload())
        }
    })
